import { MainNavigation } from "melco-ui";

import { MainMenu } from "./MainMenu";
import { useTranslation } from "react-i18next";
import { useAppDomain } from "../../hooks/appdomain/useAppDomain";

export const ControlCenterMainNavigation: React.FC = () => {
  const { t } = useTranslation();

  const { logoSelected,
    collapsedLogoSelected } = useAppDomain();

  return (
    <MainNavigation
      appName={t("app_name")}
      logo={logoSelected}
      logoCollapsed={collapsedLogoSelected}
      mainMenu={<MainMenu />}
    />
  );
};
